import React, { useState, useEffect } from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter,
  FormGroup,
  Row,
  Col,
  Input,
  Label
} from "reactstrap";
import { Formik, Form } from "formik";
import TextInput from "../../../components/common/FormsInput/FormInput";
import LocationSelectBox from "../../../components/common/FormsInput/LocationSelectBox";
import UploadBlock from "../../../components/common/UploadBlock";
import { operatorSchema, operatorInit, operatorUpdateSchema } from "./../schema";
import { roleItems } from "../../../utils/constants";
import LoaderUI from '../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension } from "../../../utils/constants";
import { validationMessage } from "../../../utils/validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
toast.configure();

const AddOperatorModal = ({ title, showModel, _toggle, addOperator, updateOperator, operatorDetail, disabled, locations, lodder }) => {



  const [payload, setPlayload] = useState({
    ...operatorInit,
    email: operatorDetail?.email,
    password: operatorDetail?.password,
    phone: operatorDetail?.phone,
    fname: operatorDetail?.fname,
    lname: operatorDetail?.lname,
    location: operatorDetail?.location?._id,
    confirmPassword: operatorDetail?.confirmPassword,
    purchase_advice: operatorDetail?.purchase_advice
  });
  const [avtar, setAvtar] = useState('');
  const [logo, setLogo] = useState('');
  const [passwordType, setPasswordType] = useState("password");
  const [confirmpasswordType, setconfirmPasswordType] = useState("password");


  useEffect(() => {
    setPlayload({
      ...operatorInit,
      email: operatorDetail?.email,
      password: operatorDetail?.password,
      phone: operatorDetail?.phone,
      fname: operatorDetail?.fname,
      lname: operatorDetail?.lname,
      location: operatorDetail?.location?._id,
      confirmPassword: operatorDetail?.confirmPassword,
      purchase_advice: operatorDetail?.purchase_advice
    })
  }, [operatorDetail]);


  useEffect(() => {
    if (!operatorDetail?._id) {
      locations = locations.filter(item => item.deleted === false);
    }
  });

  /**
   * @description method use to add operator
   * @param {object} params form params
   * @param {Instance} status form status/valiations err
   */
  const submitForm = (params, status) => {
    let body = new FormData();
    body.append("logo", logo);
    body.append("fname", params.fname);
    body.append("lname", params.lname);
    body.append("email", params.email.toLowerCase());
    body.append("phone", params.phone);
    body.append("role", roleItems[1]);
    body.append("location", params.location);
    body.append("purchase_advice", params?.purchase_advice || false);
    if (!operatorDetail?._id)
      body.append("password", params.password);

    operatorDetail?._id ? updateOperator(body, operatorDetail?._id, res => {
      setAvtar('');
    }) : addOperator(body, res => {
      setAvtar('');
    })

  };

  /**
   * @description method use to check file type
   * @param {object} 
   */
  const fileCheckImg = (obj) => {
    var fileExtension = imageExtension;
    if (obj) {
      if (!fileExtension.includes(obj.name.split('.').pop())) {
        return true;
      }
      return false;
    }
    return false;
  }

  /**
   * @description method use to show uploaded image
   * @param {object} event form event
   */
  const _handleFileUpload = (event) => {

    var result = fileCheckImg(event);
    if (!result) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        if (fileReader.readyState === 2) {
          setAvtar(fileReader.result);
        }
      };
      fileReader.readAsDataURL(event);
      setLogo(event);
    } else {
      toast.error(validationMessage.imageReq, toasterConfig);
    }

  };


  /**
    * @description method use to close add operator modal
    */
  const toggle = () => {

    setAvtar();
    setLogo();
    _toggle()
  };

  /**
  * @togglePassword method call to submit valid form
  */

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }

  /**
  * @toggleconfirmPassword method call to submit valid form
  */

  const toggleconfirmPassword = () => {
    if (confirmpasswordType === "password") {
      setconfirmPasswordType("text")
      return;
    }
    setconfirmPasswordType("password")
  }

  return (
    <>
      <Modal isOpen={showModel} toggle={toggle} backdrop="static">
        <Formik
          initialValues={payload}
          enableReinitialize
          validationSchema={operatorDetail?._id ? operatorUpdateSchema : operatorSchema}
          onSubmit={submitForm}
        >
          {(formik) => (<Form >
            <ModalHeader>
              {title}
              <Button color="link" onClick={toggle}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <g data-name="Group 651" transform="translate(-1535 -134)">
                    <g
                      fill="#fff"
                      stroke="#000"
                      strokeWidth="2"
                      data-name="Ellipse 30"
                      opacity="0.3"
                      transform="translate(1535 134)"
                    >
                      <circle cx="17" cy="17" r="17" stroke="none"></circle>
                      <circle cx="17" cy="17" r="16" fill="none"></circle>
                    </g>
                    <path
                      d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                      data-name="Icon ionic-ios-close"
                      opacity="0.3"
                      transform="translate(1534.289 132.789)"
                    ></path>
                  </g>
                </svg>
              </Button>
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <label>Upload Image</label>
                <UploadBlock name={"user"} avtar={avtar} detail={operatorDetail} handleFileUpload={(event) => _handleFileUpload(event)} />
              </FormGroup>
              <Row>
                <Col sm="6">
                  <TextInput
                    name="fname"
                    placeholder="Enter first name"
                    value={formik?.values?.fname}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="First Name"
                  />
                </Col>
                <Col sm="6">
                  <TextInput
                    name="lname"
                    placeholder="Enter last name"
                    value={formik?.values?.lname}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="Last Name"
                  />
                </Col>
                <Col sm="6">
                  <TextInput
                    name="email"
                    placeholder="Enter your email"
                    value={formik?.values?.email}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="Email Address"
                  />
                </Col>
                <Col sm="6">
                  <TextInput
                    name="phone"
                    placeholder="Enter phone number"
                    value={formik?.values?.phone}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="Phone"
                  />
                </Col>
                <Col sm="6">
                  <LocationSelectBox
                    placeholder="Select Work Group"
                    name="location"
                    value={formik?.values?.location}
                    onChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue('location', e?.target?.value)
                    }
                    }
                    isRequired={true}
                    label="Work Group"
                    options={locations}
                  />
                </Col>



                {!operatorDetail._id && (<Col sm="6">
                  <TextInput
                    name="password"
                    type={passwordType}
                    placeholder="Enter password"
                    value={formik?.values?.password}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="Password"
                    isIcon
                    togglePassword={togglePassword}
                    passwordType={passwordType}
                    passwordHint
                  />

                </Col>)}
                {!operatorDetail._id && (<Col sm="6">
                  <TextInput
                    name="confirmPassword"
                    type={confirmpasswordType}
                    placeholder="Confirm Password"
                    value={formik?.values?.confirmPassword}
                    onChange={formik.handleChange}
                    isRequired={true}
                    label="Confirm Password"
                    isIcon
                    togglePassword={toggleconfirmPassword}
                    passwordType={confirmpasswordType}
                  />
                </Col>
                )}
                <Col sm="6">
                  <Label className="d-inline-flex align-items-center checkBoxCell">
                    <Input
                      type="checkbox"
                      name="purchase_advice"
                      defaultChecked={formik?.values?.purchase_advice}
                      onChange={(e) => {
                        formik.setFieldValue('purchase_advice', e.target.checked);
                      }}
                    />
                    <span className="txt">
                      Purchase Advice Upload Allowed
                    </span>
                  </Label>

                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="link" onClick={toggle} className="cancel-btn">
                Cancel
              </Button>
              <Button
                disabled={disabled}
                color="secondary"
                type="submit"
              >
                {!operatorDetail._id && 'Submit'}
                {operatorDetail._id && 'Update'}
              </Button>
            </ModalFooter>
          </Form>)}
        </Formik>
      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default AddOperatorModal;
